import { cva, VariantProps } from "class-variance-authority";
import { ComponentProps, MouseEvent } from "react";
import { twMerge } from "tailwind-merge";

type ButtonProps = VariantProps<typeof buttonStyles> &
  ComponentProps<"button"> & {
    placeholder?: string;
    onClick?: (e: MouseEvent<HTMLButtonElement>)=> void
    children?: React.ReactNode;
  };

const buttonStyles = cva(
  [
    " px-5 py-3 text-sm border font-gilroy-medium text-body rounded-full w-fit text-nowrap bg-black text-white mr-2 ",
  ],
  {
    variants: {
      variant: {
        default: [],
        icon: [],
      },
    },
  },
);

export const Button = ({
  variant,
  className,
  children,
  onClick,
  ...props
}: ButtonProps) => {
  return (
    <button
      {...props}
      className={twMerge(className, buttonStyles({ variant }))}
      onClick={onClick}
    >
      <div className="flex  justify-center items-center gap-2">{children}</div>
    </button>
  );
};
